export default "__VITE_ASSET__t0VUqcQD__"